import { useState } from "react";
import { Box, Typography } from "@mui/material";
import CustomButton from "../../../UIElements/CustomButton";
import CancelModalButton from "../../../UIElements/CustomModal/CancelModalButton";
import CustomAlert from "../../../UIElements/CustomAlert";
import DownloadBtn from "../../../UIElements/DownloadBtn";
import UploadButton from "../../../UIElements/UploadButton";
import CustomChip from "../../../UIElements/CustomChip";
import ReactSvgIcon from "../../../UIElements/ReactSvgIcon";
import { ReactComponent as CloseSM } from "../../../../public/icons/CloseSM.svg";
import { ReactComponent as DownloadIcon } from "../../../../public/icons/DownloadIcon.svg";
import { extractDocumentPdfName } from "../../../../helpers";

export default function ContractManagerModalContent({
    onFinished,
    downloadContract,
    contractSignedUrl,
    generateContract,
}: {
    onFinished: Function;
    downloadContract: Function;
    generateContract: Function;
    contractSignedUrl?: string;
}) {
    const [contractDownloaded, setContractDonwloaded] = useState<any>(null);
    const [contractName, setContractName] = useState<string>(
        contractSignedUrl ? extractDocumentPdfName(contractSignedUrl) : ""
    );
    const [key, setKey] = useState(0); // Clé dynamique pour forcer le re-rendering du composant

    const onUploadContarct = (event: any) => {
        const file = event.target.files[0];
        setContractDonwloaded(file);
        setContractName(file.name);
        setKey((prevKey) => prevKey + 1);
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "2rem",
                    flex: "1 0 0",
                    "@media (max-width:1024px)": {
                        width: "100%",
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "0.5rem",
                        flex: "1 0 0",
                        alignSelf: "stretch",
                    }}
                >
                    <Typography
                        sx={{
                            alignSelf: "stretch",
                            color: "#023",
                            fontFamily: "Roboto",
                            fontSize: "1.25rem",
                            fontQtyle: "normal",
                            fontWeight: 700,
                            lineHeight: "normal",
                        }}
                    >
                        Gérer votre contrat
                    </Typography>
                    <CustomAlert
                        variant="filled"
                        severity="info"
                        label={`Votre dossier ne sera pas soumis si vous n'avez pas chargé le contrat signé et daté.`}
                        sx={{
                            display: "flex",
                            padding: "1rem",
                            alignItems: "center",
                            //gap: "2rem",
                            borderRadius: "0.75rem",
                            border: "1px solid #0082DE",
                            width: "-webkit-fill-availabl",
                            ".MuiAlert-icon": {
                                width: "1.25rem",
                                height: "1.25rem",
                                color: "#0082DE",
                            },
                            ".MuiAlert-message": {
                                fex: "1 0 0",
                                color: "#023",
                                fontFamily: "Roboto",
                                fontSize: "0.875rem",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "120%",
                            },
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "0.5rem",
                        flex: "1 0 0",
                        alignSelf: "stretch",
                    }}
                >
                    <Typography
                        sx={{
                            alignSelf: "stretch",
                            color: "#023",
                            fontFamily: "Roboto",
                            fontSize: "0.875rem",
                            fontQtyle: "normal",
                            fontWeight: 400,
                            lineHeight: "1.25rem",
                        }}
                    >
                        1. Veuillez <b>télécharger</b>
                    </Typography>
                    <DownloadBtn
                        label={"le contrat"}
                        title="Télécharger le contrat"
                        customsx={{
                            margin: 0,
                            padding: "0.5rem 1rem",
                            "@media (max-width:1024px)": {
                                width: "100%",
                                marginTop: 0,
                            },
                        }}
                        // disabled={contractDownloaded}
                        onClick={async () => {
                            await generateContract();
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "0.5rem",
                        flex: "1 0 0",
                        alignSelf: "stretch",
                    }}
                >
                    <Typography
                        sx={{
                            alignSelf: "stretch",
                            color: "#023",
                            fontFamily: "Roboto",
                            fontSize: "0.875rem",
                            fontQtyle: "normal",
                            fontWeight: 400,
                            lineHeight: "1.25rem",
                        }}
                        dangerouslySetInnerHTML={{
                            __html: `2. <b>Signer</b>, <b>dater</b> le contrat, puis le
                            recharger en cliquant sur`,
                        }}
                    />

                    {contractSignedUrl ? (
                        <Typography
                            sx={{
                                alignSelf: "stretch",
                                color: "#023",
                                fontFamily: "Roboto",
                                fontSize: "0.875rem",
                                fontQtyle: "normal",
                                fontWeight: 400,
                                lineHeight: "1.25rem",
                            }}
                            dangerouslySetInnerHTML={{
                                __html: `<b>Attention</b> ! Le contrat <b>a déjà été signé</b>`,
                            }}
                        />
                    ) : null}
                    <UploadButton
                        label="Téléverser le contrat"
                        customsx={{
                            "@media (max-width:1024px)": {
                                width: "100%",
                                marginTop: 0,
                            },
                        }}
                        key={key}
                        inputprops={{
                            onChange: onUploadContarct,
                        }}
                    />
                    {contractName ? (
                        <CustomChip
                            sx={{
                                display: "flex",
                                height: "2.5rem",
                                padding: "1.5rem",
                                // alignItems: "center",
                                gap: "2rem",
                                alignSelf: "stretch",
                                borderRadius: "1rem",
                                border: "2px solid #E3E6E8",
                                background: "#FFF",
                                ".MuiChip-label": {
                                    color: "#023",
                                    leadingTrim: "both",

                                    textEdge: "cap",
                                    fontFamily: "Roboto",
                                    fontSize: "0.875rem",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "normal",
                                },
                            }}
                            label={contractName}
                            onDelete={async () => {
                                setContractDonwloaded(null);
                                setContractName("");
                            }}
                            deleteIcon={
                                !contractSignedUrl ? (
                                    <ReactSvgIcon
                                        ReactIcon={CloseSM}
                                        reactIconProps={{
                                            width: "24px",
                                            height: "24px",
                                        }}
                                    />
                                ) : (
                                    <></>
                                )
                            }
                            icon={
                                contractSignedUrl ? (
                                    <ReactSvgIcon
                                        sx={{
                                            cursor: "pointer",
                                        }}
                                        onClick={async () => {
                                            await downloadContract();
                                        }}
                                        ReactIcon={DownloadIcon}
                                        reactIconProps={{
                                            width: "1.5rem",
                                            height: "1.5rem",
                                        }}
                                    />
                                ) : (
                                    <></>
                                )
                            }
                        />
                    ) : null}
                </Box>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "2rem",
                    flex: "1 0 0",
                    width: "100%",
                }}
            >
                <CustomButton
                    onClick={async () => {
                        await onFinished(contractDownloaded);
                    }}
                    label="Terminer"
                    customsx={{
                        width: "100%",
                    }}
                    disabled={!contractDownloaded}
                />
                <CancelModalButton
                    customsx={{
                        width: "100%",
                    }}
                />
            </Box>
        </Box>
    );
}
